import styled from 'styled-components';
import {Code as MantineCode} from '@mantine/core';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;

  @media (max-width: 975px) {
    min-width: fit-content;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 1fr;
    gap: 0;
  }
`;

export const Label = styled.label`
  font-weight: 600;
  color: ${(props) => props.theme.colors.text};
  align-self: flex-start;
`;

export const Code = styled(MantineCode)`
  height: 100%;
  padding: 10px;
  width: 100%;
  background-color: ${(props) => props.theme.colors.card};
`;
